import HttpClient from "../../../services/http-client";
import { ITableResponse } from "../../../../model/scp/purchase/response/tables-response";

const defaultPath = 'Base';

const listModality = async (idInstrumentSummons?: number): Promise<ITableResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Modality`,
        params: { idInstrumentSummons }
    }).then((response) => Object.assign([] as unknown as ITableResponse, response.data));
};

const listDisputeMode = async (idInstrumentSummons?: number): Promise<ITableResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/DisputeMode`,
        params: { idInstrumentSummons }
    }).then((response) => Object.assign([] as unknown as ITableResponse, response.data));
};


const listInstrumentSummons = async (): Promise<ITableResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/InstrumentSummons`
    }).then((response) => Object.assign([] as unknown as ITableResponse, response.data));
};

const listLegalSupport = async (idInstrumentSummons?: number, idModality?: number): Promise<ITableResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/LegalSupport`,
        params: { idInstrumentSummons, idModality }
    }).then((response) => Object.assign([] as unknown as ITableResponse, response.data));
};



const listSituationPurchase = async (): Promise<ITableResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/SituationPurchase`
    }).then((response) => Object.assign([] as unknown as ITableResponse, response.data));
};


const listLegalNature = async (): Promise<ITableResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/LegalNature`
    }).then((response) => Object.assign([] as unknown as ITableResponse, response.data));
};


const listTypeDocument = async (type?: number): Promise<ITableResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/TypeDocument`,
        params: { type }
    }).then((response) => Object.assign([] as unknown as ITableResponse, response.data));
};

const listJudgmentCriteria = async (idModality?: number | null | undefined): Promise<ITableResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/JudgmentCriteria`,
        params: { idModality }
    }).then((response) => Object.assign([] as unknown as ITableResponse, response.data));
};

const listMaterialService = async (idModality: number | null | undefined): Promise<ITableResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/MaterialService`,
        params: { idModality }
    }).then((response) => Object.assign([] as unknown as ITableResponse, response.data));
};

const listPurchaseItemSituation = async (): Promise<ITableResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/PurchaseItemSituation`
    }).then((response) => Object.assign([] as unknown as ITableResponse, response.data));
};

const listBenefitType = async (idModality: number | null | undefined): Promise<ITableResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/BenefitType`,
        params: { idModality }
    }).then((response) => Object.assign([] as unknown as ITableResponse, response.data));
};

const listCategoryItemPurchase = async (idModality?: number | null | undefined): Promise<ITableResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/CategoryItemPurchase`,
        params: { idModality }
    }).then((response) => Object.assign([] as unknown as ITableResponse, response.data));
};

const listTypeContract = async (): Promise<ITableResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/TypeContract`
    }).then((response) => Object.assign([] as unknown as ITableResponse, response.data));
};

const listCategoryProcess = async (): Promise<ITableResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/CategoryProcess`
    }).then((response) => Object.assign([] as unknown as ITableResponse, response.data));
};



const BaseAppService = {
    listModality, listBenefitType,listLegalNature, listTypeContract, listCategoryProcess, listCategoryItemPurchase, listLegalSupport, listDisputeMode, listInstrumentSummons, listJudgmentCriteria, listPurchaseItemSituation, listMaterialService, listTypeDocument, listSituationPurchase
};

export default BaseAppService;